import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { DEBUG } from "./Constants";

import MapStation from "./pages/map/MapStation";
import MapCommonUse from "./pages/map/MapCommonUse";
import MapAmateur from "./pages/map/MapAmateur";
import MapShip from "./pages/map/MapShip";
import MapPublicRainfall from "./pages/map/MapPublicRainfall";
import MapPublicTown from "./pages/map/MapPublicTown";
import MapCellularSearch from "./pages/map/MapCellularSearch";
import MapCellularStats from "./pages/map/MapCellularStats";
import MapCellularCommon from "./pages/map/MapCellularCommon";
import MapStatsAnalysis from "./pages/map/MapStatsAnalysis";
import MapStatsStation from "./pages/map/MapStatsStation";
import MapStatsCellular from "./pages/map/MapStatsCellular";
import MapFusionResource from "./pages/map/MapFusionResource";
import MapRadioStats from "./pages/map/MapRadioStats";
import MapRadioRegional from "./pages/map/MapRadioRegional";
import MapLandUsage from "./pages/map/MapLandUsage";
import MapFusionCountry from "./pages/map/MapFusionCountry";
import MapWifi from "./pages/map/MapWifi";
import { Alert, Select } from "antd";
import parse from "url-parse";

import "./App.css";
import "./pages/map/Layout.scss";
import MapFusionPopulation from "./pages/map/MapFusionPopulation";
import SpectrumDashboard from "./pages/spectrum/SpectrumDashboard";
import MapSpecificRadio from "./pages/map/MapSpecificRadio";
import MapNationalParkSignal from "./pages/map/MapNationalParkSignal";
import MapJob from "./pages/map/MapJob";
import Map5g from "./pages/map/Map5g";
import MapSpecificAma from "./pages/map/MapSpecificAma";
import MapSpecificShip from "./pages/map/MapSpecificShip";
import MapResourceUserStats from "./pages/map/MapResourceUserStats";
import MapWifiDensity from "./pages/map/MapWifiDensity";
import ReactDOM from "react-dom";
//import axe from "@axe-core/react";
import MapPublicStation from "./pages/map/MapPublicStation";
import MapPublicStatStation from "./pages/map/MapPublicStatStation";
import MapJointuseUtil from "./pages/map/MapJointuseUtil";

import MapImpCheckSearch from "./pages/map/MapImpCheckSearch";
import MapImpCheckSignal from "./pages/map/MapImpCheckSignal";
import MapImpCheckTraffic from "./pages/map/MapImpCheckTraffic";
import MapImpCheckMap from "./pages/map/MapImpCheckMap";
//axe(React, ReactDOM, 10000);

const COMPONENT_MAP = {
	
  // 무선국정보 > 일반무선국 > 공공 무선국 찾기
  '/gis/publicStation.do': [MapPublicStation, '무선국정보 > 일반무선국 > 공공 무선국 찾기'],  // ?menuNo=300629 로변경 300709 에서
  // 무선국정보 > 일반무선국 > 공공 지역별 무선국 현황
  '/gis/publicStatStation.do': [MapPublicStatStation, '무선국정보 > 일반무선국 > 공공 지역별 무선국 현황'],  // ?menuNo=300630 로변경 300710 에서
    // 무선국정보 > 일반무선국 > 이용효율 미이용률
  '/gis/jointuseUtilization.do': [MapJointuseUtil, '무선국정보 > 일반무선국 > 이용효율 미이용률'],  // ?menuNo=300631 로변경 300711 에서

  // 무선국정보 > 일반무선국 > 일반무선국 찾기
  "/gis/wavemap.do": [MapStation, "무선국정보 > 일반무선국 > 일반무선국 찾기"], // ?menuNo=300477

  // 무선국정보 > 일반무선국 > 아마추어 중계국 안내
  "/gis/amateur_station_service.do": [
    MapAmateur,
    "무선국정보 > 일반무선국 > 아마추어 중계국 안내",
  ], // ?menuNo=300505

  // 무선국정보 > 이동통신 무선국 > 이동통신 무선국 찾기
  "/gis/mobile_service.do": [
    MapCellularSearch,
    "무선국정보 > 이동통신 무선국 > 이동통신 무선국 찾기",
  ], // ?menuNo=300480

  // 무선국정보 > 이동통신 무선국 > 공용화 가능 무선국 찾기
  "/gis/common_use_service.do": [
    MapCellularCommon,
    "무선국정보 > 이동통신 무선국 > 공용화 가능 무선국 찾기",
  ], // ?menuNo=300539

  // 무선국정보 > 이동통신 무선국 > 이동통신 무선국 분포 현황
  "/gis/mobilewave_density.do": [
    MapCellularStats,
    "무선국정보 > 이동통신 무선국 > 이동통신 무선국 분포 현황",
  ], // ?menuNo=30301

  // 무선국정보 > 이동통신 무선국 > 5g 기지국 현황
  "/gis/gis_5g.do": [Map5g, "무선국정보 > 이동통신 무선국 > 5G 기지국 현황"], // ?menuNo=300576

  // 무선국정보 > 공공 안전/생활 무선국마을방송 무선국 찾기
  // 현재) 리액트 단에서는 gisViewId=GIS_000003 인자를 체크하고 있지 않습니다.
  "/gis/town_radiomap.do": [
    MapPublicTown,
    "무선국정보 > 공공 안전/생활 무선국 > 마을방송 무선국 찾기",
  ], // ?menuNo=300511&gisViewId=GIS_000003

  // 무선국정보 > 공공 안전/생활 무선국산악지역 이동통신 찾기
  "/gis/nationalpark_service.do": [
    MapNationalParkSignal,
    "무선국정보 > 산악지역 이동통신 찾기",
  ],

  // 무선국정보 > 이동통신 무선국 > 이행점검무선국 찾기
  '/gis/ImpCheck_service_search.do': [MapImpCheckSearch, '무선국정보 > 이동통신 무선국 > 이행점검무선국 찾기'],   // ?menuNo=300621
   // 무선국정보 > 지도로 보는 이행점검
  '/gis/ImpCheck_map.do': [MapImpCheckMap, '무선국정보 > 지도로 보는 이행점검'],  // ?menuNo=300622
  // 무선국정보 > 이행점검 전파수신레벨
  '/gis/ImpCheck_service_signal.do': [MapImpCheckSignal, '무선국정보 > 이행점검 전파수신레벨'], // ?menuNo=300624
 // 무선국정보 > 이행점검 트래픽속도
  '/gis/ImpCheck_service_traffic.do': [MapImpCheckTraffic, '무선국정보 > 이행점검 트래픽속도'], // ?menuNo=300635

  // 무선국정보 > 공공 안전/생활 무선국우량경보 무선국 찾기
  "/gis/gis_rainfall_shape.do": [
    MapPublicRainfall,
    "무선국정보 > 공공 안전/생활 무선국우량경보 무선국 찾기",
  ], // ?menuNo=300509

  // 무선국정보 > 선박 무선국 > 어업정보 무선국 찾기
  "/gis/coastal_area_service.do": [
    MapShip,
    "무선국정보 > 선박 무선국 > 어업정보 무선국 찾기",
  ], // ?menuNo=300512

  // 무선국정보 >  공공 와이파이 > 와이파이 찾기
  "/gis/wifiService.do": [
    MapWifi,
    "무선국정보 >  공공 와이파이 > 와이파이 찾기",
  ], // ?menuNo=300541

  // 무선국정보 >  공공 와이파이 > 와이파이 분포
  "/gis/wavedata_density.do": [
    MapWifiDensity,
    "무선국정보 >  공공 와이파이 > 와이파이 분포",
  ],

  // 전파정보 LAB > 지도로 보는 무선국 > 무선국 종합 분석
  "/rwdinfolabstats/viewYearByClsByFyerCmpr.do": [
    MapStatsAnalysis,
    "전파정보 LAB > 지도로 보는 무선국 > 무선국 종합 분석",
  ], // ?menuNo=50203

  // 전파정보 LAB > 지도로 보는 무선국 > 무선국 현황
  "/rwdinfolabstats/viewYearByClsByStats.do": [
    MapStatsStation,
    "전파정보 LAB > 지도로 보는 무선국 > 무선국 현황",
  ], // ?menuNo=50203

  // 전파정보 LAB > 지도로 보는 무선국 > 지역별 이동통신 현황
  "/rwdinfolabstats/viewYearBySvcByStats.do": [
    MapStatsCellular,
    "전파정보 LAB > 지도로 보는 무선국 > 지역별 이동통신 현황",
  ], // ?menuNo=50202

  // 전파정보 LAB > 지도로 보는 무선국 > 선박무선국 현황
  "/rwdinfolabstats/viewSpcifyRdwStats.do": [
    MapSpecificShip,
    "전파정보 LAB > 지도로 보는 무선국 > 선박무선국 현황",
  ],

  //  전파정보 LAB > 지도로 보는 무선국 > 간이무선국 현황
  "/rwdinfolabstats/viewSpcifyRdwStats2.do": [
    MapSpecificRadio,
    "전파정보 LAB > 지도로 보는 무선국 > 간이무선국 현황",
  ], // ?menuNo=300534

  //    전파정보 LAB > 지도로 보는 무선국 > 아마추어무선국 현황
  "/rwdinfolabstats/viewSpcifyRdwStats3.do": [
    MapSpecificAma,
    "전파정보 LAB > 지도로 보는 무선국 > 아마추어무선국 현황",
  ],

  //  전파정보 LAB > 전파자원 이용자 지수 > 전파자원 이용자 지수 -> 데이터 만든 후 views와 연동
  "/rwdinfolabstats/viewAreaDvltIdex.do": [
    MapResourceUserStats,
    "전파정보 LAB > 전파자원 이용자 지수 > 전파자원 이용자 지수",
  ],

  // 전파정보 LAB > 융합으로 보는 전파정보 > 전파자원 분석
  "/rwdinfolabstats/viewRdwAnalsStatsData1.do": [
    MapFusionResource,
    "전파정보 LAB > 융합으로 보는 전파정보 > 전파자원 분석",
  ], // ?menuNo=50301

  // 전파정보 LAB > 융합으로 보는 전파정보 > 전파와 국토
  "/rwdinfolabstats/viewRdwAnalsStatsData2.do": [
    MapFusionCountry,
    "전파정보 LAB > 융합으로 보는 전파정보 > 전파와 국토",
  ], // ?menuNo=50302

  // 전파정보 LAB > 융합으로 보는 전파정보 > 전파와 인구
  "/rwdinfolabstats/viewRdwAnalsStatsData3.do": [
    MapFusionPopulation,
    "전파정보 LAB > 융합으로 보는 전파정보 > 전파와 인구",
  ], // ?menuNo=50302

  // 전파정보 활용 > 라디오방송 주파 > 지역별 주파수 찾기
  "/gis/radiomap.do": [
    MapRadioStats,
    "전파정보 활용 > 라디오방송 주파 > 지역별 주파수 찾기",
  ], // ?menuNo=40101

  // 전파정보 활용 > 라디오방송 주파 > 방송 수신 정보
  "/gis/broadcast_reception.do": [
    MapRadioRegional,
    "전파정보 활용 > 라디오방송 주파 > 방송 수신 정보",
  ], // ?menuNo=300433

  // 토지정보 활용 > 토지와 무선국 > 토지용도와 무선국
  "/gis/usagemap.do": [
    MapLandUsage,
    "토지정보 활용 > 토지와 무선국 > 토지용도와 무선국",
  ], // ?menuNo=300521

  // 공동사용 (기관사용자)
  "/gis/wavemapPmsNo.do": [MapCommonUse, "공동사용(기관사용자)"], // ?menuNo=300478

  // 주파수 정보 > 주파수 용도 > 대역별 용도 검색 (내부자)
  "/useSearch.do": [
    SpectrumDashboard,
    "주파수 정보 > 주파수 용도 > 대역별 용도 검색 (내부자)",
  ],

  // 일자리맵
  "/gis/waveworkmap_service.do": [MapJob, "(구현중) 일자리 지도"], // menuNo=300581

  // '/map/spectrum/': '(미구현) 주파수',
  // '/map/fusion/population/': '전파와 인구',
  // '/map/land/dev-district/': '(미구현) 택지 개발지구도 무선 -> 토지용도와무선국 페이지로 갈음합니다',
};

function App() {
  const currentPath = window.CURRENT_URL
    ? parse(window.CURRENT_URL).pathname
    : window.location.pathname;

  // console.log(`currentPath: ${currentPath}`);

  const Component = Object.entries(COMPONENT_MAP)
    .filter(([url, [map_component, label]]) => url === currentPath)
    .map(([url, [map_component, label]]) => map_component)[0];

  // FIXME: containerOffsetTop을 Context API로 만들어, 각 Map 컴포넌트에 전달하기
  const [containerOffsetTop, setContainerOffsetTop] = useState(0);
  useEffect(() => {
    const { y, top } = document
      .getElementById("react-root")
      .getBoundingClientRect();
    setContainerOffsetTop(y || top);
  }, []);

  const isMapComponent =
    window.location.pathname.indexOf("/gis/") > -1 ||
    window.location.pathname.indexOf("/rwdinfolabstats/") > -1;
  const divStyle = isMapComponent
    ? {
        overflowY: "hidden",
        position: "relative",
        height: `calc(100vh - ${containerOffsetTop}px)`,
      }
    : {};

  return (
    <BrowserRouter>
      <div style={divStyle} className="map-base-container-r">
        {/* FIXME: 몽키패칭. yarn build 시에 컴포넌트를 못 찾는 이슈 */}
        {/*<Switch>*/}
        {/*  {Object.entries(COMPONENT_MAP).map(([url, [map_component, label]]) =>*/}
        {/*    <Route exact path={url} component={map_component} key={url} />*/}
        {/*  )}*/}
        {/*</Switch>*/}
        {Component && <Component />}
        {!Component && (
          <Alert
            message={`Error) ${currentPath}에 매칭되는 가용한 컴포넌트가 없습니다.`}
            type={"error"}
          />
        )}

        {DEBUG && (
          <div style={{ position: "fixed", left: 15, bottom: 40, width: 650 }}>
            <Select
              defaultValue={currentPath}
              style={{ width: "100%" }}
              onChange={(pathname) => {
                window.location.href = pathname;
              }}
            >
              {Object.entries(COMPONENT_MAP).map(
                ([url, [map_component, label]]) => (
                  <Select.Option value={url} key={url}>
                    {label} -> {url}
                  </Select.Option>
                )
              )}
            </Select>
          </div>
        )}
      </div>
    </BrowserRouter>
  );
}

export default App;
